import React from 'react';
import { Video, Image } from 'lucide-react';
import VideoGrid from './VideoGrid';
import ImageGrid from './ImageGrid';

const BackgroundTab = ({
  videos,
  images,
  selectedBg,
  selectedImageBg,
  hoveredVideo,
  defaultVideoId,
  defaultImageId,
  uploadingVideo,
  uploadingImage,
  selectedAnimation,
  onBgSelect,
  onImageBgSelect,
  onHoverVideo,
  onVideoRename,
  onVideoToggleLock,
  onVideoDelete,
  onSetDefaultVideo,
  onVideoUpload,
  onImageRename,
  onImageToggleLock,
  onImageDelete,
  onSetDefaultImage,
  onImageUpload,
  onAnimationChange,
  testIdPrefix = ''
}) => {
  return (
    <div className="p-4 space-y-4">
      <div className="flex gap-2">
        <button
          onClick={() => onImageBgSelect(null)}
          className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${
            selectedImageBg === null
              ? 'bg-purple-500/30 border border-purple-400/50 text-purple-400'
              : 'bg-white/5 text-white/60 hover:bg-white/10'
          }`}
        >
          <Video className="w-4 h-4" />
          Vidéos
        </button>
        <button
          onClick={() => { if (selectedImageBg === null && images.length > 0) onImageBgSelect(0); }}
          className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${
            selectedImageBg !== null
              ? 'bg-amber-500/30 border border-amber-400/50 text-amber-400'
              : 'bg-white/5 text-white/60 hover:bg-white/10'
          }`}
        >
          <Image className="w-4 h-4" />
          Images
        </button>
      </div>

      {selectedImageBg === null ? (
        <VideoGrid
          videos={videos}
          selectedBg={selectedBg}
          selectedImageBg={selectedImageBg}
          hoveredVideo={hoveredVideo}
          defaultVideoId={defaultVideoId}
          uploadingVideo={uploadingVideo}
          onBgSelect={onBgSelect}
          onHoverVideo={onHoverVideo}
          onVideoRename={onVideoRename}
          onVideoToggleLock={onVideoToggleLock}
          onVideoDelete={onVideoDelete}
          onSetDefaultVideo={onSetDefaultVideo}
          onVideoUpload={onVideoUpload}
          testIdPrefix={testIdPrefix}
        />
      ) : (
        <ImageGrid
          images={images}
          selectedImageBg={selectedImageBg}
          defaultImageId={defaultImageId}
          uploadingImage={uploadingImage}
          selectedAnimation={selectedAnimation}
          onImageBgSelect={onImageBgSelect}
          onImageRename={onImageRename}
          onImageToggleLock={onImageToggleLock}
          onImageDelete={onImageDelete}
          onSetDefaultImage={onSetDefaultImage}
          onImageUpload={onImageUpload}
          onAnimationChange={onAnimationChange}
          testIdPrefix={testIdPrefix}
        />
      )}
    </div>
  );
};

export default BackgroundTab;
